<template>
    <property-base :label="resource('JourneyBuilder_FilterSettings_Delay')">
        <time-period v-model="newValue" />
    </property-base>
</template>

<script>

//import {timeUnit} from '../../../../../Util/time';
import resources from '../../../../../../Util/Mixins/resources';

import PropertyBase from './../JourneyConnectionPropertyBase.vue';
import TimePeriod from '../../../../../../Components/Inputs/JiraStyleTimePeriod.vue';

export default {
    name: 'journey-connection-delay',
    mixins: [resources],
    components: {
        PropertyBase,
        TimePeriod
    },
    created() {
        this.newValue = this.value;
    },
    data() {
        return {
            newValue: null
        }
    },
    watch: {
        newValue(value) {
            this.$emit('input', value);
        }
    },
    props: {
        value: {
            type: Object
        }
    }
};
</script>

<style lang="scss" scoped>

</style>